import PartnersDonation from "./PartnersDonation";

export default PartnersDonation;
